import React from "react";
import { ArrowRightIcon, LockIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
type CtaButtonProps = {
  label: string;
  sub?: string;
  id?: string;
  tone?: "light" | "dark";
};
export function CtaButton({
  label,
  sub,
  id,
  tone = "light"
}: CtaButtonProps) {
  return <div id={id} className="flex w-full flex-col items-center" data-id="element-29" data-mp="ck9crhjtxga7">
      <a href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[1.05rem] font-black uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#0A6B34] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-dark active:translate-y-1 active:shadow-[0_2px_0_0_#0A6B34] focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-2 focus-visible:outline-sun sm:text-xl" data-id="element-30" data-mp="cn5bv97eyb08">
        <span className="text-balance" data-id="element-31" data-mp="159ztlycuiwa0">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-32" data-mp="157dcp842f4f4" />
      </a>
      {sub && <p className={`mt-4 flex items-start justify-center gap-1.5 text-center text-sm font-bold ${tone === "dark" ? "text-white/80" : "text-ink/70"}`} data-id="element-33" data-mp="39z14z3bzy3pr">
          <LockIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-34" data-mp="3jy8h5n6zvsba" />
          <span data-id="element-35" data-mp="3ov8riaavnh87">{sub}</span>
        </p>}
    </div>;
}